import { isTelegramApp } from '@/utils/isTelegramApp';

export function useHapticFeedback() {
  const triggerHapticFeedback = (
    type: 'light' | 'medium' | 'heavy' = 'medium',
  ) => {
    if (isTelegramApp()) {
      (window as any).Telegram?.WebApp?.HapticFeedback?.impactOccurred(type);
    } else if ('vibrate' in navigator) {
      const duration = type === 'light' ? 20 : type === 'medium' ? 50 : 100;
      navigator.vibrate(duration);
    }
  };

  return { triggerHapticFeedback };
}
